import styled from 'styled-components';

export const wrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;
export const tabs = styled.div`
    display: flex;
    gap: 6px;
    padding: 8px 14px 0;
    border-bottom: 1px solid #e2e8f0;
    flex: 0 0 auto;
`;
export const tab = styled.button`
    border: 0;
    background: transparent;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    margin-bottom: -1px;
    &.active {
        color: #2563eb;
        border-bottom-color: #2563eb;
    }
`;
export const frame = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    position: relative;
    iframe {
        width: 100%;
        height: 100%;
        border: 0;
        display: block;
    }
`;
export const panel = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 18px;
`;
export const hint = styled.div`
    font-size: 13px;
    color: #64748b;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 14px;
`;
export const empty = styled.div`
    font-size: 13px;
    color: #94a3b8;
    padding: 6px 0;
`;
export const catRow = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 10px;
`;
export const catHead = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    .name { font-size: 15px; font-weight: 700; }
    .price { font-size: 13px; color: #64748b; margin-inline-start: auto; }
`;
export const swatch = styled.span`
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid #00000022;
    flex: 0 0 auto;
`;
export const ticketList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
export const ticketChip = styled.button`
    border: 1.5px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 999px;
    padding: 5px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    &.on {
        border-color: #2563eb;
        background: #2563eb;
        color: #fff;
    }
`;
export const actions = styled.div`
    display: flex;
    justify-content: flex-start;
    padding-top: 8px;
`;
export const saveBtn = styled.button`
    border: 0;
    background: #2563eb;
    color: #fff;
    border-radius: 8px;
    padding: 9px 26px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:disabled { opacity: 0.6; cursor: default; }
`;
